import { Routes, Route } from 'react-router-dom';
import { Navigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';

import HostNavLinks from './HostNavLinks';

import OmeMeetContextProvider from '../../state/omeMeet/OmeMeetContextProvider';
import OmeMeetEntryContextProvider from '../../state/omeMeetEntry/OmeMeetEntryContextProvider';
import OmeMeetEntryInvitationsContextProvider from '../../state/omeMeetEntryInvitations/OmeMeetEntryInvitationsContextProvider';
import OmeTimeStandardContextProvider from '../../state/omeTimeStandard/OmeTimeStandardContextProvider';
import TimeStandardAgeGroupContextProvider from '../../state/timeStandardAgeGroup/TimeStandardAgeGroupContextProvider';
import OmeFeeTypeContextProvider from '../../state/omeFeeType/OmeFeeTypeContextProvider';
import OmeMeetDateValidationContextProvider from '../../state/omeMeetDateValidation/OmeMeetDateValidationContextProvider';

import MeetContextProvider from '@usas/ui-web/state/meet/MeetContextProvider';
import MeetFiltersContextProvider from '@usas/ui-web/state/meet/MeetFiltersContextProvider';
import SearchMeetContextProvider from '@usas/ui-web/state/searchMeet/SearchMeetContextProvider';
import OrgRoleContextProvider from '@usas/ui-web/state/orgRole/OrgRoleContextProvider';
import CompetitonGenderTypeContextProvider from '@usas/ui-web/state/competitionGender/CompetitionGenderTypeContextProvider';
import EventCompetitonGenderTypeContextProvider from '@usas/ui-web/state/eventCompetitionGender/EventCompetitionGenderTypeContextProvider';
import TimeStandardTypeContextProvider from '@usas/ui-web/state/timeStandardType/TimeStandardTypeContextProvider';
import MeetSessionsContextProvider from '@usas/ui-web/state/meetSessions/MeetSessionsContextProvider';
import SessionContextProvider from '@usas/ui-web/state/time/SessionContextProvider';
import TimeContextProvider from '@usas/ui-web/state/time/TimeContextProvider';
import TimeFiltersContextProvider from '@usas/ui-web/state/time/TimeFiltersContextProvider';
import TimesOrganizationContextProvider from '@usas/ui-web/state/time/TimesOrganizationContextProvider';
import LeftNavModalContextProvider from '@usas/ui-web/state/leftNavModal/LeftNavModalContextProvider';
import BasePersonFiltersContextProvider from '@usas/ui-web/state/personBase/BasePersonFiltersContextProvider';
import BasePersonContextProvider from '@usas/ui-web/state/personBase/BasePersonContextProvider';
import PersonGeneralContextProvider from '@usas/ui-web/state/personGeneral/PersonGeneralContextProvider';

import OmeHostLoading from './omeHostLoading/OmeHostLoading';
import OmeMeetInfo from './hostRegistration/omeMeetInfo/OmeMeetInfo';
import OmeMeetInfoNonHQ from './hostRegistration/omeMeetInfo/OmeMeetInfoNonHQ';
import OmeMeetInfoCoursePriority from './hostRegistration/omeMeetInfo/OmeMeetInfoCoursePriority';
import OmeEligibility from './hostRegistration/omeEligibility/OmeEligibility';
import OmeEligibilityNonHQ from './hostRegistration/omeEligibility/OmeEligibilityNonHQ';
import OmeEligibilityBonusEvents from './hostRegistration/omeEligibility/OmeEligibilityBonusEvents';
import OmeEligibilityCoachPasses from './hostRegistration/omeEligibility/OmeEligibilityCoachPasses';
import OmeRestrictions from './hostRegistration/omeRestrictions/OmeRestrictions';
import OmeRestrictionsNonHQ from './hostRegistration/omeRestrictions/OmeRestrictionsNonHQ';
import OmeRestrictionsType from './hostRegistration/omeRestrictions/OmeRestrictionsType';
import OmeRestrictionsTypeMembership from './hostRegistration/omeRestrictions/OmeRestrictionsTypeMembership';
import OmeRestrictionsTypeCompetitionCategory from './hostRegistration/omeRestrictions/OmeRestrictionsTypeCompetitionCategory';
import OmeRestrictionsTypeAge from './hostRegistration/omeRestrictions/OmeRestrictionsTypeAge';
import OmeSessions from './hostRegistration/omeSessions/OmeSessions';
import OmeSessionsDetail from './hostRegistration/omeSessions/OmeSessionsDetail';
import OmeAgeGroups from './hostRegistration/omeAgeGroups/OmeAgeGroups';
import OmeAgeGroupsDetail from './hostRegistration/omeAgeGroups/OmeAgeGroupsDetail';
import OmeTimeStandards from './hostRegistration/omeTimeStandards/OmeTimeStandards';
import OmeTimeStandardsDetail from './hostRegistration/omeTimeStandards/OmeTimeStandardsDetail';
import OmeEvents from './hostRegistration/omeEvents/OmeEvents';
import OmeEventsDetail from './hostRegistration/omeEvents/OmeEventsDetail';
import OmeAlternateEventDetail from './hostRegistration/omeEvents/OmeAlternateEventDetail';
import OmeMeets from './hostRegistration/omeMeets/OmeMeets';
import OmeMeetsDetail from './hostRegistration/omeMeets/OmeMeetsDetail';
import OmeMeetsDetailNonHQ from './hostRegistration/omeMeets/OmeMeetsDetailNonHQ';
import OmeMeetsDetailPricingAdditionalPurchases from './hostRegistration/omeMeets/OmeMeetsDetailPricingAdditionalPurchases';
import OmeSubmit from './hostRegistration/omeSubmit/OmeSubmit';

import LoadingModal from '@usas/ui-web/components/dialogs/LoadingModal';
import SecuredRouteElement from '@usas/ui-web/components/security/SecuredRouteElement';

const HostRoutes = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return (
    <Routes>
      <Route path={navRoutes['OME_HOST_LOADING']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_LOADING']}
            editElement={<OmeHostLoading redirectNavLink={HostNavLinks.OME_MEET_INFO} />} />
        }
      />
      <Route path={navRoutes['OME_HOST_MEET_INFO']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_MEET_INFO']}
            editElement={<OmeMeetInfo />}
            readOnlyElement={<OmeMeetInfoNonHQ />} />
        }
      />
      <Route path={navRoutes['OME_HOST_MEET_INFO_COURSE_PRIORITY']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_MEET_INFO_COURSE_PRIORITY']}
            editElement={<OmeMeetInfoCoursePriority />} />
        }
      />
      <Route path={navRoutes['OME_HOST_ELIGIBILITY']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_ELIGIBILITY']}
            editElement={<OmeEligibility />}
            readOnlyElement={<OmeEligibilityNonHQ />} />
        }
      />
      <Route path={navRoutes['OME_HOST_ELIGIBILITY_BONUS_EVENTS']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_ELIGIBILITY_BONUS_EVENTS']}
            editElement={<OmeEligibilityBonusEvents />} />
        }
      />
      <Route path={navRoutes['OME_HOST_ELIGIBILITY_COACH_PASSES']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_ELIGIBILITY_COACH_PASSES']}
            editElement={<OmeEligibilityCoachPasses />} />
        }
      />
      <Route path={navRoutes['OME_HOST_RESTRICTIONS']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_RESTRICTIONS']}
            editElement={<OmeRestrictions />}
            readOnlyElement={<OmeRestrictionsNonHQ />} />
        }
      />
      <Route path={navRoutes['OME_HOST_RESTRICTIONS_TYPE']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_RESTRICTIONS_TYPE']}
            editElement={<OmeRestrictionsType />} />
        }
      />
      <Route path={navRoutes['OME_HOST_RESTRICTIONS_TYPE_MEMBERSHIP']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_RESTRICTIONS_TYPE_MEMBERSHIP']}
            editElement={<OmeRestrictionsTypeMembership />} />
        }
      />
      <Route path={navRoutes['OME_HOST_RESTRICTIONS_TYPE_COMPETITION_CATEGORY']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_RESTRICTIONS_TYPE_COMPETITION_CATEGORY']}
            editElement={<OmeRestrictionsTypeCompetitionCategory />} />
        }
      />
      <Route path={navRoutes['OME_HOST_RESTRICTIONS_TYPE_AGE']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_RESTRICTIONS_TYPE_AGE']}
            editElement={<OmeRestrictionsTypeAge />} />
        }
      />
      <Route path={navRoutes['OME_HOST_SESSIONS']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_SESSIONS']}
            editElement={<OmeSessions />} />
        }
      />
      <Route path={navRoutes['OME_HOST_SESSIONS_DETAIL']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_SESSIONS_DETAIL']}
            editElement={<OmeSessionsDetail />} />
        }
      />
      <Route path={navRoutes['OME_HOST_AGE_GROUPS']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_AGE_GROUPS']}
            editElement={<OmeAgeGroups />} />
        }
      />
      <Route path={navRoutes['OME_HOST_AGE_GROUPS_DETAIL']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_AGE_GROUPS_DETAIL']}
            editElement={<OmeAgeGroupsDetail />} />
        }
      />
      <Route path={navRoutes['OME_HOST_TIME_STANDARDS']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_TIME_STANDARDS']}
            editElement={<OmeTimeStandards />} />
        }
      />
      <Route path={navRoutes['OME_HOST_TIME_STANDARDS_DETAIL']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_TIME_STANDARDS_DETAIL']}
            editElement={<OmeTimeStandardsDetail />} />
        }
      />
      <Route path={navRoutes['OME_HOST_EVENTS']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_EVENTS']}
            editElement={<OmeEvents />} />
        }
      />
      <Route path={navRoutes['OME_HOST_EVENTS_DETAIL']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_EVENTS_DETAIL']}
            editElement={<OmeEventsDetail />} />
        }
      />
      <Route path={navRoutes['OME_HOST_EVENTS_DETAIL_ALTERNATE']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_EVENTS_DETAIL_ALTERNATE']}
            editElement={<OmeAlternateEventDetail />} />
        } />
      <Route path={navRoutes['OME_HOST_OME_MEETS']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_OME_MEETS']}
            editElement={<OmeMeets />} />
        }
      />
      <Route path={navRoutes['OME_HOST_OME_MEETS_DETAIL']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_OME_MEETS_DETAIL']}
            editElement={<OmeMeetsDetail />}
            readOnlyElement={<OmeMeetsDetailNonHQ />} />
        }
      />
      <Route path={navRoutes['OME_HOST_OME_MEETS_DETAIL_PRICING_ADDITIONAL_PURCHASES']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_OME_MEETS_DETAIL_PRICING_ADDITIONAL_PURCHASES']}
            editElement={<OmeMeetsDetailPricingAdditionalPurchases />}
          />
        }
      />
      <Route path={navRoutes['OME_HOST_SUBMIT']?.path}
        element={
          <SecuredRouteElement
            navRoute={navRoutes['OME_HOST_SUBMIT']}
            editElement={<OmeSubmit />} />
        }
      />
      <Route path={'/'} element={<Navigate to={navRoutes['OME_HOST_MEET_TEMPLATE']?.route} replace />} />
    </Routes>
  );
};

const HostContextProviders = ({ children }) => (
  <LeftNavModalContextProvider>
    <MeetContextProvider>
      <MeetFiltersContextProvider>
        <SearchMeetContextProvider>
          <OmeMeetContextProvider>
            <OmeMeetEntryContextProvider>
              <OmeMeetEntryInvitationsContextProvider>
                <TimeStandardTypeContextProvider>
                  <OmeTimeStandardContextProvider>
                    <OrgRoleContextProvider>
                      <CompetitonGenderTypeContextProvider>
                        <EventCompetitonGenderTypeContextProvider>
                          <MeetSessionsContextProvider>
                            <TimeContextProvider>
                              <TimeFiltersContextProvider>
                                <TimesOrganizationContextProvider>
                                  <SessionContextProvider>
                                    <TimeStandardAgeGroupContextProvider>
                                      <BasePersonContextProvider>
                                        <BasePersonFiltersContextProvider>
                                          <PersonGeneralContextProvider>
                                            <OmeFeeTypeContextProvider>
                                              <OmeMeetDateValidationContextProvider>
                                                {children}
                                              </OmeMeetDateValidationContextProvider>
                                            </OmeFeeTypeContextProvider>
                                          </PersonGeneralContextProvider>
                                        </BasePersonFiltersContextProvider>
                                      </BasePersonContextProvider>
                                    </TimeStandardAgeGroupContextProvider>
                                  </SessionContextProvider>
                                </TimesOrganizationContextProvider>
                              </TimeFiltersContextProvider>
                            </TimeContextProvider>
                          </MeetSessionsContextProvider>
                        </EventCompetitonGenderTypeContextProvider>
                      </CompetitonGenderTypeContextProvider>
                    </OrgRoleContextProvider>
                  </OmeTimeStandardContextProvider>
                </TimeStandardTypeContextProvider>
              </OmeMeetEntryInvitationsContextProvider>
            </OmeMeetEntryContextProvider>
          </OmeMeetContextProvider>
        </SearchMeetContextProvider>
      </MeetFiltersContextProvider>
    </MeetContextProvider>
  </LeftNavModalContextProvider>
);

const HostContextStateAndRoutes = () => (
  <HostContextProviders>
    <HostRoutes />
  </HostContextProviders>
);

export default HostContextStateAndRoutes;